// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"a690d282","512":"801a90e0"}[chunkId] + ".chunk.css";
};